import api from '@/plugins/api';
import { toString } from '@/utils/date';

export default class {
  parent = null;

  html = '';

  __date = {
    from: new Date(),
    to: null,
  };

  items = [];

  loading = false;

  constructor(parent) {
    this.parent = parent;
  }

  get date() {
    return this.__date.from;
  }

  set date(date) {
    this.__date.from = new Date(date);
    this.__date.from.setDate(1);
    this.__date.to = new Date(this.__date.from);
    this.__date.to.setMonth(this.__date.to.getMonth() + 1);
    this.__date.to.setDate(0);
    this.get();
  }


  get() {
    const { id } = this.parent;
    const { from, to } = this.__date;
    this.loading = true;
    return api.tour.client
      .dates({
        id,
        to: toString(to),
        from: toString(from),
      })
      .then((data) => {
        this.set(data.availableDates);
        return this;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  set(data) {
    const { from, to } = this.__date;
    if (!from || !to) return;
    const min = new Date();
    min.setDate(min.getDate() - 1);
    this.items = new Array(to.getDate())
      .fill('')
      .map((_, i) => {
        const date = new Date(from);
        date.setDate(i + 1);
        const value = toString(date);
        const item = date.getTime() > min.getTime() ? data.find(j => j.date.serialized === value) : null;
        return {
          value,
          id: item?.tour?.value || '',
          disabled: this.getDisabled(item),
          active: this.parent.id === item?.tour?.value,
          price: item?.price || 0,
          date,
        };
      });
  }
  getDisabled(item) {
    if (undefined === item) return true;
    return false;
  }
}
